import { UserDataType } from "../../../../context/types";
import { ProductFormT } from "../../../../types/productTypes";
import { deepEqual } from "../../../../utils/deepEqual";

const prepareFormUpdatedValues = (
  watchedData: ProductFormT,
  initialData: ProductFormT | null,
  user: UserDataType | null,
  isVariobelOnlyField: boolean
) => {
  const updatedValues: Partial<ProductFormT> = {};
  const newTimelineEntriesText = [];

  // Compare watched data with initial data
  // Used to get the values that changed instead of sending whole form(watchedData);
  // Result is in: updatedValues, newTimelineEntriesText
  for (const key in watchedData) {
    // Stop the loop if initialData is not available
    if (!initialData) break;

    // Skip the "timelineEntries" key because it's not needed in this step
    if (key === "timelineEntries") continue;

    const updatedValue = watchedData[key];
    const initialValue = initialData[key];

    const newTimelineEntriesTextItem = {
      previous: initialValue,
      current: updatedValue,
    };

    const valuesAreEqual = deepEqual(updatedValue, initialValue);

    if (!valuesAreEqual) {
      updatedValues[key] = updatedValue;
      newTimelineEntriesText.push({ [key]: newTimelineEntriesTextItem });
    }
  }

  console.log(newTimelineEntriesText)

  const now = new Date();
  const newTimelineEntries = {
    type: "update",
    time: now,
    admin: user!._id,
    text: JSON.stringify(newTimelineEntriesText),
  };

  // timelineEntries is not part of type 'ProductFormInputs'
  // it is gotten during data fetch in EDIT MODE
  // @ts-ignore
  const existingTimelineEntries =
    initialData?.timelineEntries;

  // Skip this for porez; has no timeline field
  if (isVariobelOnlyField) {
    updatedValues["timelineEntries"] = [
      ...(existingTimelineEntries ? existingTimelineEntries : []),
      newTimelineEntries,
    ];
  }

  return updatedValues;
};


export default prepareFormUpdatedValues